export default {
	data(){
		return {
			current:1,
			pageSize:20,
			total:0,
		}
	},
	methods:{
		pageSizeChange(current,size){
			this.pageSize = size
			this.current =1
			this.getlist({current:1,pageSize:size})
		},
        pageChange(current,pageSize){
            this.current = current
            this.pageSize = pageSize
            this.getlist({current,pageSize})
        },
	}
}